import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { message, Spin, Row, Divider, Tooltip, Icon, Button, Tag, Table, Input } from 'antd';
import { PopUpForm } from '../../../lib/ui/popupform';
import Title from 'antd/lib/typography/Title';
import ErrorWrapper from '../../../lib/error_wrapper';
import { overrideHeaderTitle, overrideHeaderBack, NetworkDelaySearch, formatMoney } from '../../../lib/util';
import { BasicHeader } from '../../../components/basic_header';
import { TransparentButton } from '../../../components/basic_items';

const queryString = require('query-string');


const flags_cols = ({ onEditPressed }) => [
    {
        title: "Name",
        dataIndex: "name",
        key: "name"
    }, {
        title: "Actions",
        dataIndex: 'id',
        key: 'action',
        width: 100,
        render: (id, data) => {
            return <span>
                <Button
                    type='link'
                    style={{ padding: 0 }}
                    onClick={() => {
                        typeof onEditPressed === 'function' && onEditPressed(id, data);
                    }}>Edit</Button>
            </span>
        }
    }
];
class DatatypeFlags extends Component {
    constructor(props) {
        super(props)
        this.datatype_id = props.match.params.datatype_id;

        this.state = {
            form_data: {},
            edit_id: null,
            form_visibility: false,
            filter_query: {
                per_page: 100,
                page: 1
            },
        }
        this.list_flags = RESTExecutor.list().config({
            label: 'flag_list',
            params: {
                ...this.state.filter_query
            }
        }).forId(this.datatype_id).connect(props.domains.datatype);

        this.post_flags = RESTExecutor.post().config({
            label: 'flag_list'
        }).callbacks((success) => {
            message.success("Label Added");
            this.setState({
                form_data: {},
                edit_id: null,
                form_visibility: false
            })
            this.list_flags.execute();
        }).connect(props.domains.datatype);

        this.patch_flags = RESTExecutor.patch().config({
            label: 'flag_detail',
            params: {}
        }).callbacks((success) => {
            message.success("Label Updated");
            this.setState({
                form_data: {},
                edit_id: null,
                form_visibility: false
            })
            this.list_flags.execute();
        }).connect(props.domains.datatype);

        // this.list_flags.execute();

        this.delay_search = new NetworkDelaySearch();


    }

    handlePostPatchFlag = (data) => {
        if (this.state.edit_id) {
            this.patch_flags.config({
                params: {
                    datatype_id: this.datatype_id,
                    flag_id: this.state.edit_id
                }
            }).execute(data);
        } else {
            this.post_flags.forId(this.datatype_id).execute(data);
        }
    }
    stateUpdater = ({
        stateKey,
        valueKey,
        value,
        appendObj = {},
        callback
    }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }
    render() {
        let list_flags_resp = this.list_flags.response();
        let rowsData = (list_flags_resp.result && list_flags_resp.result.rows) || [];
        let rowsMeta = list_flags_resp.meta || {};

        let post_flags_resp = this.post_flags.response();
        let patch_flags_resp = this.patch_flags.response();
        const { filter_query } = this.state;
        return <div>

<BasicHeader  title="Labels"
                    right={[
                        <TransparentButton
                            label="Add New"
                            hint="Add New Label"
                            onClick={() => {
                                this.setState({
                                    edit_id: null,
                                    form_data: {},
                                    form_visibility: true
                                })
                            }}

                        />,
                    ]}

                />
<div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
                         <Input.Search
                                    autoFocus
                                allowClear
                                    placeholder="Search For"
                                    style={{
                                    }}
                                    value={filter_query.query}
                                    onChange={(e) => {
                                        this.stateUpdater({
                                            stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {
                                                this.delay_search.onSearch(() => {
                                                    this.props.history.push({
                                                        // pathname:"users",
                                                        search:queryString.stringify({...this.state.filter_query,per_page:100,page:1})
                                                    })
                                                })
                                            }
                                        })
                                    }}/>

                        </div></div>
            <ErrorWrapper error={list_flags_resp} onReload={() => {
                this.datatype_id = this.props.match.params.datatype_id;
                this.list_flags.forId(this.datatype_id).execute();
            }}>
                <div className='default-card' style={{
                    padding: 0
                }}>
                    {/* <CustomHeader /> */}


                    <Table
                        className='main-table'
                        loading={list_flags_resp.fetching}
                        size='small'
                        scroll={{ x: true }}
                        pagination={{
                            simple: false,
                            position: 'bottom',
                            onChange: (current, size) => {
                                this.props.history.push({
                                    // pathname:"users",
                                    search:queryString.stringify({...this.state.filter_query,per_page:size,page:current})
                                })
                            },
                            defaultCurrent: 1,
                            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                            pageSize: (rowsMeta && rowsMeta.requested_count),
                            total: (rowsMeta && rowsMeta.total_count),
                            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        }} 
                        rowKey={(record) => record.id} columns={flags_cols({
                            onEditPressed: (id, data) => {
                                this.setState({
                                    edit_id: id,
                                    form_data: data,
                                    form_visibility: true
                                })

                            },

                        })} dataSource={rowsData} />


                </div>
            </ErrorWrapper>
            <PopUpForm
                title="Label"
                forCreate={this.state.edit_id
                    ? false
                    : true}
                initialData={this.state.form_data}
                fields={[{ index: 'name', name: "Label Name", type: 'text', required: true }]}
                open={this.state.form_visibility}
                networkState={this.state.edit_id
                    ? patch_flags_resp
                    : post_flags_resp}
                onClose={() => {
                    this.setState({ form_visibility: false, form_data: {}, edit_id: null })
                }}
                onSubmit={(data) => {
                    this.handlePostPatchFlag(data);
                }} />

        </div>
    }

    componentDidMount() {
        overrideHeaderTitle("Labels List");
        overrideHeaderBack('back')
        let new_filter_query={};
        if(this.props.location&&this.props.location.search){
        const parsed = queryString.parse(this.props.location.search);
        new_filter_query=parsed;
        }
        this.setState({
        filter_query:{
            per_page:100,
            page:1,
            ...new_filter_query
        }
        },()=>{
        this.list_flags.config({
            params: {
            ...this.state.filter_query
            }
        }).execute()
        })

    }
    componentWillUnmount() {
        overrideHeaderBack(null)
    }
    componentWillReceiveProps (nextProps) {
        var olddatatype_id = this.props.match.params.datatype_id;
        var newdatatype_id = nextProps.match.params.datatype_id;


        if(olddatatype_id!==newdatatype_id || (
          this.props.location&&(this.props.location.search!==nextProps.location.search)
        )){
            this.datatype_id=newdatatype_id;
            const parsed = queryString.parse(nextProps.location.search);
            this.setState({
                filter_query:{
                    per_page:100,
                    page:1,
                    ...parsed
                }
                },()=>{
                this.list_flags.forId(this.datatype_id).config({
                    params: {
                    ...this.state.filter_query
                    }
                }).execute()
                })
    
        }
    }

}

export default withDomains(DatatypeFlags, "datatype");
